<div data-test-id="modal-default" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title">{{ context.title | translate }}</h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>

  <div class="modal-body" #categoryForm>
    <form [formGroup]="form">
      <!-- Category/Subcategory radio button selection -->
      <label data-test-id="category-node-label" class="form-label dialog-label">{{
        'CATEGORY_NODE_TYPE_HINT' | translate
      }}</label>
      <div>
        <div class="row">
          <button data-test-id="category-radio-button" class="col-auto col-md-auto col-lg-3 col-xl-2 category-type-btn">
            <input
              formControlName="categoryNodeType"
              type="radio"
              id="NodeTypeCategory"
              name="categoryNodeType"
              class="category-radio"
              value="Category"
            />
            <label for="NodeTypeCategory" class="form-label category-label">{{ 'CATEGORY_HINT' | translate }}</label>
          </button>
        </div>
        <div class="row">
          <button
            data-test-id="subcategory-radio-button"
            class="col-auto col-md-auto col-lg-3 col-xl-2 category-type-btn"
          >
            <input
              formControlName="categoryNodeType"
              type="radio"
              id="NodeTypeSubcategory"
              name="categoryNodeType"
              class="category-radio"
              value="Subcategory"
            />
            <label for="NodeTypeSubcategory" class="form-label category-label">{{
              'SUBCATEGORY_HINT' | translate
            }}</label>
          </button>
        </div>
      </div>

      <!-- Parent Id input -->
      <div
        data-test-id="wrap-parent-category-elemen"
        class="category-title"
        *ngIf="form.get('categoryNodeType').value === 'Subcategory'"
      >
        <div class="row">
          <label data-test-id="search-label" class="form-label">{{ 'PARENT_CATEGORY_HINT' | translate }}</label>
        </div>
        <div class="row">
          <input
            type="text"
            [ngbTypeahead]="searchParentCategories"
            [inputFormatter]="formatParentCategory"
            [resultFormatter]="formatParentCategory"
            [editable]="false"
            (selectItem)="onSelectParentCategory($event)"
            (input)="onParentCategoryInput($event)"
            (blur)="onParentCategoryInputBlur()"
            class="form-control"
            id="parentId"
            name="parentId"
            #parentCategoryInput
            data-test-id="parent-category-element"
            placeholder="Type to select parent node."
            [class.is-invalid]="form.get('parentId').invalid && form.get('parentId').touched"
          />
        </div>

        <!-- Parent id errors -->
        <small
          class="text-danger"
          data-test-id="error-message"
          *ngIf="form.get('parentId').errors && form.get('parentId').touched"
        >
          <ng-container>
            {{ 'INVALID_PARENT_ID_ERROR' | translate }}
          </ng-container>
        </small>
      </div>

      <!-- Category Title input -->
      <div data-test-id="wrap-category-title-element" #categoryTitle class="category-title">
        <div class="row">
          <label data-test-id="category-title-label" class="form-label"
            >{{ 'CATEGORY_TITLE_LABEL' | translate }} *</label
          >
        </div>
        <div class="row">
          <input
            type="text"
            formControlName="categoryTitle"
            class="form-control"
            id="categoryTitle"
            name="categoryTitle"
            placeholder="Enter new entry title."
            (blur)="trimTitle()"
            (keydown)="onKeyDown()"
            data-test-id="category-title-element"
            [class.is-invalid]="form.get('categoryTitle').invalid && form.get('categoryTitle').touched"
          />
        </div>
      </div>

      <!-- Display error message for category title -->
      <small
        class="text-danger"
        data-test-id="error-message"
        *ngIf="form.get('categoryTitle').errors && form.get('categoryTitle').touched"
      >
        <ng-container>
          {{ 'INVALID_CATEGORY_TITLE_ERROR' | translate }}
        </ng-container>
      </small>

      <div #formButtons class="form-buttons">
        <button
          data-test-id="create-button"
          class="btn btn-primary text-white"
          type="submit"
          (click)="submit()"
          [disabled]="form.invalid"
        >
          {{ 'BTN_CREATE_HINT' | translate }}
        </button>
        <button data-test-id="cancel-button" class="btn btn-secondary text-white" type="button" (click)="onDismiss()">
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="modal-footer" data-test-id="modal-footer"></div>
</div>
